import axios from 'axios';
import { asyncHttpReqStarted, asyncHttpReqEnded } from '@store/common/actions';
import store from '../store';
import axiosConfig from './config';
import { addAxiosInterceptors } from './axiosInstance';

// DO NOT use this instance, use axiosInstance instead
// queries update redux state causing unnecessary re-renders
// this will be depricated with old trends

const instance = axios.create(axiosConfig);
axios.defaults.params = { mode: (window.conviva.module || 'EI').toLocaleLowerCase() };

function onRequestIntercept(config) {
  store.dispatch(asyncHttpReqStarted());
  return config;
}

function onResponseIntercept(response) {
  store.dispatch(asyncHttpReqEnded());
  return response;
}

function handleError(error) {
  store.dispatch(asyncHttpReqEnded());
  return Promise.reject(error);
}

instance.interceptors.request.use(onRequestIntercept, handleError);

instance.interceptors.response.use(onResponseIntercept, handleError);

addAxiosInterceptors(instance);

export default instance;
export { axiosConfig };
